import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)

// Formats in the session's own timezone, so every view of a session shows the
// same date regardless of where the manager is.
let formatInSessionTz = (ts: string, tz: string, format: string): string => {
  try {
    return dayjs.utc(ts).tz(tz).format(format)
  } catch {
    return dayjs(ts).format(format)
  }
}

export let formatSessionMeta = (ts: string, tz: string): string =>
  formatInSessionTz(ts, tz, 'MMM D, YYYY · h:mm A')

export let formatSessionDate = (ts: string, tz: string): string =>
  formatInSessionTz(ts, tz, 'MMM D, YYYY')
